import React, {useState} from 'react'
import Link from 'next/link';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import ImgTheme from 'components/common/ImgTheme';
import {UIHelper} from 'components/helpers/UIHelper';

import {handleChangeDrawerState} from 'redux/actions/ThemeActions';

import {IoCloseSharp} from 'react-icons/io5';
import {Modal} from 'antd';
import _ from 'lodash';
import QuickAccessStyles from '../styles/navigation-quick-access.module.scss'

const QuickAccessScreen = ({setShowMenuModal}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const ThemeState = useSelector(state => state.Theme)

    const handleShowSupport = (data) => {
        setShowMenuModal(false)
        dispatch(handleChangeDrawerState({
            showDrawer: false,
            showSupportDrawer: false,
            showNotificationDrawer: false,
            ...data
        }))
    }

    const LinkIcon = ({iconUrl, text, link, as = undefined, deactivated = false, ...props}) => (
        link ?
            <Link href={link} as={as}>
                <a onClick={e => deactivated ? e.preventDefault() : setShowMenuModal(false)}>
                    <div className={deactivated ? 'grayscale' : ''}>
                        <ImgTheme alt={text} src={iconUrl}/>
                        <span>{text}</span>
                    </div>
                </a>
            </Link>
            :
            <a href={'#'} onClick={e => e.preventDefault()}>
                <div className={deactivated ? 'grayscale' : ''} {...props}>
                    <ImgTheme alt={text} src={iconUrl}/>
                    <span>{text}</span>
                </div>
            </a>
    )

    return <div className={QuickAccessStyles.quick_access}>
        <div className={`${QuickAccessStyles.quick_access__section} with-border mt-9`}>
            <LinkIcon link={'/wallets'} as={'/wallets'}
                      iconUrl={'/images/quick-access/coin-list.svg'} text={t('quick_access_coin_list')}/>
            <LinkIcon link={'/quick-trade/[[...qtrade]]'} as={'/quick-trade/btc'}
                      iconUrl={'/images/quick-access/quick-trade.svg'} text={t('quick_access_quick_order')}/>
            <LinkIcon link={'/market/[[...trade]]'} as={'/market/btc-irt'}
                      iconUrl={'/images/quick-access/trade.svg'} text={t('quick_access_trade')}/>
            <LinkIcon link={'/active-trades'} iconUrl={'/images/quick-access/active-trades.svg'}
                      text={t('quick_access_active_trades')}/>

            <LinkIcon link={'/history'} as={'/history'}
                      iconUrl={'/images/quick-access/history.svg'} text={t('quick_access_history')}/>
            <LinkIcon link={'/wallets'} as={'/wallets'}
                      iconUrl={'/images/quick-access/wallets.svg'} text={t('quick_access_wallets')}/>
            <LinkIcon link={'/invite'} as={'/invite'}
                      iconUrl={'/images/quick-access/invite.svg'} text={t('quick_access_invite')}/>
            <LinkIcon link={'/profile'} as={'/profile'}
                      iconUrl={'/images/quick-access/profile.svg'} text={t('quick_access_profile')}/>
        </div>

        <div className={`${QuickAccessStyles.quick_access__section} mt-5`}>
            <div className={'title'}><p className={'mb-0 text-2xs'}>{t('quick_access_title_wallets')}</p></div>

            <LinkIcon link={'/wallets/[[...wallet_data]]'} as={'/wallets/irt/deposit'}
                      iconUrl={'/images/quick-access/deposit-fiat.svg'} text={t('quick_access_deposit_fiat')}/>
            <LinkIcon link={'/wallets/[[...wallet_data]]'} as={'/wallets/irt/withdraw'}
                      iconUrl={'/images/quick-access/withdraw-fiat.svg'} text={t('quick_access_withdraw_fiat')}/>
            <LinkIcon link={'/credit-card'} as={'/credit-card'}
                      iconUrl={'/images/quick-access/add-card.svg'} text={t('quick_access_add_card')}/>
            <LinkIcon link={'/'}
                      deactivated={true}
                      iconUrl={'/images/quick-access/profit-loss.svg'} text={t('quick_access_profit_loss')}/>

            <LinkIcon link={'/wallets'} as={'/wallets'}
                      iconUrl={'/images/quick-access/deposit-crypto.svg'} text={t('quick_access_deposit_crypto')}/>
            <LinkIcon link={'/wallets'} as={'/wallets'}
                      iconUrl={'/images/quick-access/withdraw-crypto.svg'} text={t('quick_access_withdraw_crypto')}/>
            <LinkIcon link={'/'}
                      deactivated={true}
                      iconUrl={'/images/quick-access/full-trade.svg'} text={t('quick_access_full_trade')}/>
        </div>

        <div className={`${QuickAccessStyles.quick_access__section} mt-5`}>
            <div className={'title'}><p className={'mb-0 text-2xs'}>{t('quick_access_title_history')}</p></div>
            <LinkIcon link={'/history/trades'} as={'/history/trades'}
                      iconUrl={'/images/quick-access/history-trades.svg'} text={t('quick_access_history_trades')}/>
            <LinkIcon link={'/history/crypto'} as={'/history/crypto'}
                      iconUrl={'/images/quick-access/history-crypto.svg'}
                      text={t('quick_access_history_deposit_withdraw_crypto')}/>
            <LinkIcon link={'/history/fiat'} as={'/history/fiat'}
                      iconUrl={'/images/quick-access/history-fiat.svg'}
                      text={t('quick_access_history_deposit_withdraw_fiat')}/>
        </div>

        <div className={`${QuickAccessStyles.quick_access__section} mt-5`}>
            <div className={'title'}><p className={'mb-0 text-2xs'}>{t('quick_access_other')}</p></div>
            <LinkIcon link={'/api'} as={'/api'}
                      deactivated={true}
                      iconUrl={'/images/quick-access/api.svg'} text={t('quick_access_api')}/>
            <LinkIcon link={'https://pingi.co/help'}
                      iconUrl={'/images/quick-access/faq.svg'} text={t('quick_access_faq')}/>
            <LinkIcon link={null}
                      iconUrl={'/images/quick-access/support.svg'} text={t('quick_access_support')}
                      onClick={() => handleShowSupport({
                          showSupportDrawer: !ThemeState.showSupportDrawer
                      })}/>
            <LinkIcon link={'https://pingi.co/blog'} as={'https://pingi.co/blog'}
                      iconUrl={'/images/quick-access/blog.svg'} text={t('quick_access_blog')}/>
            <LinkIcon link={'/security/mfa'} as={'/security/mfa'}
                      iconUrl={'/images/quick-access/mfa.svg'} text={t('quick_access_mfa')}/>
            <LinkIcon link={'/security/change-password'} as={'/security/change-password'}
                      iconUrl={'/images/quick-access/change-password.svg'} text={t('quick_access_change_password')}/>
        </div>
    </div>
}

const MobileBottomNavigation = ({activeMenu, logoutOnly = true}) => {
    const {t} = useTranslation();
    const UserState = useSelector((state) => state.User.info);
    const ThemeState = useSelector((state) => state.Theme);
    const [showMarketTypeModal, setShowMarketTypeModal] = useState(false)
    const [showMenuModal, setShowMenuModal] = useState(false)

    const isActiveMenu = (item, activeItem) => {
        return item === activeItem ? 'active' : ''
    }

    return <div className={'mobile-bottom-navigation'}>
        {
            (logoutOnly || _.isNull(UserState)) ?
                <>
                    <div
                        className={`bottom-navigation__container home ${isActiveMenu(UIHelper.bottomNavigationMenuItems.home, activeMenu)}`}>
                        <Link href={'/'} shallow={true} scroll={true}>
                            <div>
                                <div className={'bottom-navigation__icon'}></div>
                                <span>داشبورد</span>
                            </div>
                        </Link>
                    </div>
                    <div
                        className={`bottom-navigation__container profile ${isActiveMenu(UIHelper.bottomNavigationMenuItems.profile, activeMenu)}`}>
                        <Link href={'/logout'} shallow={true} scroll={true}>
                            <div>
                                <div className={'bottom-navigation__icon'}></div>
                                <span>خروج</span>
                            </div>
                        </Link>
                    </div>
                </>
                :
                <>
                    <div
                        className={`bottom-navigation__container home ${isActiveMenu(UIHelper.bottomNavigationMenuItems.home, activeMenu)}`}>
                        <Link href={'/'} shallow={true} scroll={true}>
                            <div>
                                <div className={'bottom-navigation__icon'}></div>
                                <span>داشبورد</span>
                            </div>
                        </Link>
                    </div>
                    <div
                        className={`bottom-navigation__container markets ${isActiveMenu(UIHelper.bottomNavigationMenuItems.markets, activeMenu)}`}>
                        <Link href={'/markets'} shallow={true} scroll={true}>
                            <div>
                                <div className={'bottom-navigation__icon'}></div>
                                <span>لیست ارزها</span>
                            </div>
                        </Link>
                    </div>
                    <div
                        className={`bottom-navigation__container trade ${isActiveMenu(UIHelper.bottomNavigationMenuItems.market, activeMenu)}`}>
                        <div onClick={() => setShowMarketTypeModal(true)}>
                            <div className={'bottom-navigation__icon'}></div>
                            <span>معامله</span>
                        </div>
                    </div>
                    <div
                        className={`bottom-navigation__container wallets ${isActiveMenu(UIHelper.bottomNavigationMenuItems.wallets, activeMenu)}`}>
                        <Link href={'/wallets'} shallow={true} scroll={true}>
                            <div>
                                <div className={'bottom-navigation__icon'}></div>
                                <span>کیف‌پول</span>
                            </div>
                        </Link>
                    </div>
                    <div
                        className={`bottom-navigation__container profile ${isActiveMenu(UIHelper.bottomNavigationMenuItems.profile, activeMenu)}`}>
                        <div onClick={() => setShowMenuModal(true)}>
                            <div className={'bottom-navigation__icon'}></div>
                            <span>بیشتر</span>
                        </div>
                    </div>
                </>
        }
        <Modal
            closeIcon={<IoCloseSharp/>}
            transitionName={ThemeState.mobileView ? 'ant-move-down' : 'ant-fade'}
            title={false}
            centered={!ThemeState.mobileView}
            width={ThemeState.mobileView ? ThemeState.mobileModalWidth : ThemeState.desktopModalWidth}
            closable={true}
            open={showMarketTypeModal}
            className={ThemeState.mobileView ? 'modal-mobile' : 'modal-desktop'}
            onCancel={() => setShowMarketTypeModal(false)}
            wrapClassName={'navigation-market-type__modal'}
            footer={null}
            okButtonProps={{hidden: true}}
            cancelButtonProps={{hidden: true}}>
            <div className={'navigation-market-type__container'}>
                <div>
                    <Link as={'/quick-trade/usdt'} href={'/quick-trade/usdt'}
                          onClick={() => setShowMarketTypeModal(false)}>
                        <a>
                            <ImgTheme src={'/images/quick-access/quick-trade.svg'}
                                      alt={t('dashboard_trade_quick_description')}/>
                            <div>
                                <h3>{t('dashboard_trade_quick_title')}</h3>
                                <p>{t('dashboard_trade_quick_description')}</p>
                            </div>
                        </a>
                    </Link>
                </div>
                <div>
                    <Link as={'/market/btc-irt'} href={'/market/btc-irt'}
                          onClick={() => setShowMarketTypeModal(false)}>
                        <a>
                            <ImgTheme src={'/images/quick-access/trade.svg'} alt={t('dashboard_trade_description')}/>
                            <div>
                                <h3>{t('dashboard_trade_title')}</h3>
                                <p>{t('dashboard_trade_description')}</p>
                            </div>
                        </a>
                    </Link>
                </div>
            </div>
        </Modal>

        <Modal
            closeIcon={<IoCloseSharp/>}
            transitionName={ThemeState.mobileView ? 'ant-slide-down' : 'ant-fade'}
            title={'دسترسی سریع'}
            centered={!ThemeState.mobileView}
            width={ThemeState.mobileView ? ThemeState.mobileModalWidth : ThemeState.desktopModalWidth}
            closable={true}
            open={showMenuModal}
            className={ThemeState.mobileView ? 'modal-mobile' : 'modal-desktop'}
            onCancel={() => setShowMenuModal(false)}
            wrapClassName={QuickAccessStyles.quick_access__modal}
            footer={null}
            okButtonProps={{hidden: true}}
            cancelButtonProps={{hidden: true}}>
            {
                QuickAccessScreen({setShowMenuModal: setShowMenuModal})
            }
        </Modal>
    </div>
}

export default MobileBottomNavigation
